export default `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.5144 38.856">
  <g>
    <path class="cls-2" d="M22.7278,6.717V0H0V19.333H22.7278V12.922H35.621Zm-6.4247,7.625-.8049.805L11.02,10.654,6.5271,15.147l-.8049-.805,4.4929-4.493L5.7222,5.371l.8049-.805L11.02,9.059l4.4929-4.493.8049.805L11.81,9.864Z"/>
    <path class="cls-2" d="M40.5968,14.562a3.2345,3.2345,0,1,0-3.2342-3.234A3.2353,3.2353,0,0,0,40.5968,14.562Z"/>
    <path class="cls-2" d="M35.7238,15.528a45.8241,45.8241,0,0,1-8.7223-1.595l-1.0684,3.014a47.5523,47.5523,0,0,0,9.7029,2.518h.0585V38.856h3.2489v-9.63h3.2489v9.63h3.3221V15.528Z"/>
  </g>
</svg>`;
